export const materialDetailBuilder = () => {
    const materialDetail = {
        materialId: null,
        materialCategoryId: null,
        quantity: null,
        price: null,

        setMaterialId(materialId) {
            this.materialId = materialId
            return this;
        },

        setMaterialCategoryId(materialCategoryId) {
            this.materialCategoryId = materialCategoryId;
            return this;
        },

        setQuantity(quantity) {
            this.quantity = quantity;
            return this;
        },

        setPrice(price) {
            this.price = price;
            return this;
        },

        build() {
            return this;
        },
    };

    return materialDetail;
};